import { render } from "./Libs.vue?vue&type=template&id=01281959&scoped=true&ts=true"
import script from "./Libs.vue?vue&type=script&lang=ts"
export * from "./Libs.vue?vue&type=script&lang=ts"

import "./Libs.vue?vue&type=style&index=0&id=01281959&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01281959"]])

export default __exports__